import {analysisPeriodAction} from "../constants/actionTypes";

export const onFetchIndexAnalysisPeriodAction = (data) => {
  return {
    type: analysisPeriodAction.ON_FETCH_INDEX_ANALYSIS_PERIOD,
    data
  }
};
